<template lang="html">

<v-row class="fill-height overflow-y-auto">
  <v-col cols="12" lg="4" md="6" v-for="(item, idx) in formulaRstList" :key="idx" no-gutters>
    <v-sheet min-height="100" class="fill-height" color="transparent">
      <v-lazy class="fill-height"
        v-model="item.isActivate"
        :options="lazyOptions"
      >
        <v-card class="fill-height" rounded hover>
          <div class="d-flex flex-no-wrap justify-space-between">
            <div>
              <v-card-title>
                <span class="formulanum text-sm-left text-center" v-text="'#'+idx"></span>
                <span class="formulatitle ml-1" v-text="item.name.label"></span>
                <v-icon class="ml-1" small v-if="checkIncluded(item.name)" v-text="includedIcon"></v-icon>
                <v-btn :href="getAddress(item.uri)" target="_blank" text small>
                    <v-icon color="teal">mdi-link-variant</v-icon>
                </v-btn>
                <v-btn :href="getMediclassicsAddress(item.name.label)" target="_blank" text small>
                    <v-icon color="teal">mdi-book-open-variant</v-icon>
                </v-btn>
              </v-card-title>

              <v-card-subtitle>
                  <span class="kor" v-text="item.book.label" v-if="item.book.label!=''"></span>
                  <v-icon class="ml-1" small v-if="checkIncluded(item.book)" v-text="includedIcon"></v-icon>
              </v-card-subtitle>

              <v-card-text>

                <v-chip-group
                  column
                >
                    <v-chip
                      v-for="(hE, hI) in item.herbs" :key="hI"
                      color="green"
                      text-color="white"
                      small
                    >
                      <v-avatar left v-if="checkIncluded(hE)">
                          <v-icon small v-text="includedIcon"></v-icon>
                      </v-avatar>
                      <span class="kor" v-text="hE.label"></span>
                    </v-chip>
                </v-chip-group>

                <v-chip-group
                  active-class="deep-purple--text text--accent-4"
                  column
                >
                    <v-chip
                      v-for="(sE, sI) in item.symps" :key="sI"
                      color="primary"
                      text-color="white"
                      small
                    >
                    <v-avatar left v-if="checkIncluded(sE)">
                        <v-icon small v-text="includedIcon"></v-icon>
                    </v-avatar>
                    <span class="kor" v-text="sE.label"></span>
                    </v-chip>
                  </v-chip-group>

              </v-card-text>
            </div>

          </div>
        </v-card>
   </v-lazy>
  </v-sheet>
  </v-col>
</v-row>
    
</template>

<script>

import { helper } from "../helper.js"

const getTagsInIdxGroupScaffold = function(){
  return {
      'F': [],
      'H': [],
      'S': [],
      'B': []
    }
}

const getTagsInIdxGroup = function( tagsInIdx ) {
  let tmp = getTagsInIdxGroupScaffold()
  for( let k of tagsInIdx ){
      tmp[ k.group ].push( k.idx )
  }
  helper.log( tmp )
  return tmp
}

const decode_data = function( e, idx2name, tagsInIdxGroup ){

  let rst = {
     name: { "label": idx2name.F[ e.F ], "included": tagsInIdxGroup.F.includes( e.F ) },
     herbs: e.H.map( n => { return { label: idx2name.H[ n ], included: tagsInIdxGroup.H.includes( n ) } }),
     symps: e.S.map( n => { return { label: idx2name.S[ n ], included: tagsInIdxGroup.S.includes( n ) } }),
     book: (e.B==0)? {"label": "", "included": false} : { "label": idx2name.B[ e.B ], "included": tagsInIdxGroup.B.includes(e.B) },
     uri: e.U,
  }
  // console.log(tagsInIdxGroup)
  // helper.log( e )
  // helper.log( rst )
  return rst

}

const mediclassicsBaseUrl = "https://mediclassics.kr"

export default {
  props: ["formulaList", "dataDict", "tagsInIdx", "formulaRstIdxList", "showResultAction"],
  data: () => ({
      isLazyActive: true,
      lazyOptions: { threshold: .5 },
      // includedIcon: "mdi-star-outline"
      includedIcon: "mdi-checkbox-marked-circle"
      // formulaRstList: [],
      // showList: false
   }),
  methods: {
    getAddress( uri ) {
      return this.dataDict.etc.urlhead + uri
    },
    getMediclassicsAddress( name ){ 
      var tg = name.match(/\((.+?)\)/)
      return (tg[1])? mediclassicsBaseUrl + "/search/result?search=" + tg[1] : mediclassicsBaseUrl
    },
    checkIncluded( e ){
      return e.included
    }
  },
  computed: {
    showList() {
      if ((this.showResultAction) && ( this.formulaRstIdxList.length > 0 )) return true
      else return false
    },
    formulaRstList() {
      let rst
      let tagsInIdxGroup = getTagsInIdxGroup( this.tagsInIdx )
      if ((this.showResultAction) && ( this.formulaRstIdxList.length > 0 )) {
        rst = this.formulaRstIdxList.map( e => { return decode_data( this.formulaList[e], this.dataDict.idx2name, tagsInIdxGroup ) } )
        rst = rst.sort( (a,b) => ( ( a.herbs.length - b.herbs.length ) ) )
      } else {
        rst = []
      }
      // helper.log( rst )
      return rst
    }
  }
}

// REF
// v-lazy : https://stackoverflow.com/a/61659924
</script>

<style lang="css" scoped>
.han {
  font-size: 80%;
  line-height: 0;
  vertical-align: baseline;
}

.formulanum {
  color: orange;
  vertical-align: super;
  font-size: 10px;
}

.formulatitle {
  font-size: 20px;
}

</style>
